import React, { useEffect } from "react";
import {
  AppPlatform,
  PicData,
  PicModuleLoader,
} from "@amzn/picmodule-loader-library";
import { useParams } from "react-router";
import * as adobeAnalytics from "../../../utility/adobe-analytics";
import { PageContainer } from "@amzn/stencil-react-components/page";
import { defaultTextColor } from "../../../config/palette";
import { Col } from "@amzn/stencil-react-components/layout";
import { isDragonstone } from "../../../helpers/url-params";
import { useNavigator } from "../../../hooks/use-navigator";
import { IconArrowLeft } from "@amzn/stencil-react-components/icons";
import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";

export const PICRoute = () => {
  const [goBack] = useNavigator();

  const { applicationId, requisitionId } = useParams<{
    applicationId: string;
    requisitionId: string;
  }>();

  useEffect(() => {
    adobeAnalytics.addEventMetric(
      window,
      applicationId,
      "ash click personal information",
      {
        referrer: adobeAnalytics.interpretReferrer(document.referrer),
        jobId: requisitionId,
        isDragonstone: isDragonstone(requisitionId),
      }
    );
  }, [applicationId, requisitionId]);

  const picData: PicData = { platform: AppPlatform.ASH };
  return (
    <>
      <PageContainer color={defaultTextColor}>
        <Button
          variant={ButtonVariant.Tertiary}
          onClick={goBack}
          style={{ color: "#232F3E", fontSize: 25, border: 0 }}
        >
          <IconArrowLeft display="Pre-day 1 checklist" />
          &nbsp; Pre-day 1 checklist
        </Button>
        <Col alignItems="center" justifyContent="center" height="100%">
          <PicModuleLoader data={picData} />
        </Col>
      </PageContainer>
    </>
  );
};
